export default __webpack_public_path__ + "static/media/onboardingMobile.b29334b1.png";